import {
  input,
  computed,
  Component,
  booleanAttribute,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Transitioned } from '@shared/directives/transitioned';

import { ProgressSpinner } from '@shared/ui/progress-spinner';

export type IconButtonSize = 'small' | 'medium' | 'large' | 'xlarge';
export type IconButtonVariant = 'classic' | 'solid' | 'soft' | 'surface' | 'outlined' | 'base';
export type IconButtonColor = 'primary' | 'secondary' | 'danger';

@Component({
  selector: 'button[appIconButton], a[appIconButton]',
  imports: [ProgressSpinner],
  templateUrl: './icon-button.html',
  styleUrl: './icon-button.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [Transitioned],
  host: {
    '[class]': 'hostClasses()',
    '[attr.aria-busy]': 'loading() ? "true" : null',
    '[attr.disabled]': 'disabledAttribute()',
  },
})
export class IconButton {
  public readonly size = input<IconButtonSize>('medium');
  public readonly color = input<IconButtonColor>('primary');
  public readonly variant = input<IconButtonVariant>('base');
  public readonly loading = input(undefined, { transform: booleanAttribute });
  public readonly rounded = input(undefined, { transform: booleanAttribute });
  public readonly disabledInput = input(undefined, { alias: 'disabled', transform: booleanAttribute });

  protected readonly disabled = computed(() => this.loading() || this.disabledInput());
  protected readonly disabledAttribute = computed(() => (!this.disabled() ? null : true));

  protected readonly hostClasses = computed(() => ({
    'app-icon-button': true,
    [`app-icon-button_${this.size()}`]: true,
    [`app-icon-button_${this.variant()}`]: true,
    [`app-icon-button_${this.color()}`]: true,
    'app-icon-button_rounded': this.rounded(),
    'app-icon-button_disabled': this.disabled(),
  }));
}
